import { Injectable } from '@angular/core';
import { SignoAuditoriaService } from './signo-auditoria.service';
import { AuditoriaModulo } from '@enum/auditoria/auditoria-keys.enum';
import {
    SignoAuditoriaEvento,
    SignoAuditoriaFiltros,
} from '@interfaces/interface-bakend/auditoria/signo-auditoria-evento.interface';

/**
 * Lectura de los eventos de auditoría del flujo de inscripción O.S.
 * Aísla el módulo "InscripcionOS" del resto de la auditoría general.
 */
@Injectable({ providedIn: 'root' })
export class InscripcionesAuditoriaService {

    constructor(private signoAuditoria: SignoAuditoriaService) {}

    getEventos(filtros?: SignoAuditoriaFiltros): Promise<SignoAuditoriaEvento[]> {
        return this.signoAuditoria.getEventos({
            modulo: AuditoriaModulo.INSCRIPCION_OS,
            ...(filtros || {}),
        });
    }

    /** Todos los eventos de un mismo intento (timeline completo). */
    getEventosByTrace(traceId: string): Promise<SignoAuditoriaEvento[]> {
        return this.getEventos({ traceId });
    }

    /** Todos los eventos asociados a una solicitud (FK). */
    getEventosBySolicitud(solicitudId: string): Promise<SignoAuditoriaEvento[]> {
        return this.getEventos({ solicitudId });
    }

    exportar(filtros?: SignoAuditoriaFiltros): Promise<Blob> {
        return this.signoAuditoria.exportarEventos({
            modulo: AuditoriaModulo.INSCRIPCION_OS,
            ...(filtros || {}),
        });
    }
}
